import PlusSVG from '@web-packages/svgs/Plus';
import LeftArrowHead from '@web-packages/svgs/LeftArrowHead';
import RightArrowHead from '@web-packages/svgs/RightArrowHead';

const types = {
  none: 'none',
  leftIcon: 'leftIcon',
  rightIcon: 'rightIcon',
};

const iconTypes = {
  arrow: {
    name: 'arrow',
    left: LeftArrowHead,
    right: RightArrowHead,
  },
  plus: {
    name: 'plus',
    left: PlusSVG,
    right: PlusSVG,
  },
};

const showLeft = (type) => type === types.leftIcon;

const showRight = (type) => type === types.rightIcon;

const helper = {
  showLeft,
  showRight,
};

export { types, iconTypes, helper };
